// @ts-nocheck

export const CONFIRM_REGISTRATION_BUTTON = "CONFIRM_REGISTRATION_BUTTON";
